<template>
  <div>
    <love-map-button
        class="cropper-btn"
        @click="openImageCropper"
    >
      <span>Ladda upp bild</span>
    </love-map-button>
    <modal
        name="image-cropper-modal"
        height="auto"
        :key="'modal'"
        :pivotY="0.3"
        adaptive
        scrollable
    >
      <div class="viewport-confirm-container">
        <div class="viewport-confirm-message">
          <div class="lovemap-product-preview">
            <input
                ref="input"
                type="file"
                name="image"
                accept="image/*"
                style="display:none;"
                @change="setImage"
            />
            <section class="cropper-area">
              <div class="actions">
                <love-map-button
                    @click="rotate(-90)"
                >
                  Rotera vänster
                </love-map-button>
                <love-map-button
                    @click="rotate(90)"
                >
                  Rotera höger
                </love-map-button>


              </div>

              <div class="img-cropper">
                <vue-cropper
                    ref="cropper"
                    :aspect-ratio="aspectRatio"
                    :src="imgSrc"
                    preview=".preview"
                />
              </div>
              <div class="actions">

                <love-map-button
                    @click="reset"
                >
                  Återställ
                </love-map-button>
<!--                <love-map-button-->
<!--                    @click="cropImage"-->
<!--                >-->
<!--                  Beskär-->
<!--                </love-map-button>-->

                <love-map-button
                    @click="showFileChooser"
                >
                  Ladda upp bild
                </love-map-button>
              </div>
<!--              <textarea v-model="data"/>-->
            </section>
            <section v-if="false" class="preview-area">
              <div>
                <p>Preview</p>
                <div class="preview"/>
              </div>
              <div>
                <p>Cropped Image</p>
                <div class="cropped-image">
                  <img
                      v-if="cropImg"
                      :src="cropImg"
                      alt="Cropped Image"
                  />
                  <div v-else class="crop-placeholder"/>
                </div>
              </div>
            </section>

          </div>
        </div>
        <div class="bottom">
          <div>
            <love-map-button
                @click="cropImage"
            >
              Färdigställ
            </love-map-button>
          </div>
          <div>
            <love-map-button
                @click="closeImageCropper"
            >
              Stäng
            </love-map-button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "TxImageCropper",
  props: {
    value: {},
    layout: {},
    aspectRatio: {},
  },
  components: {
    VueCropper
  },
  watch: {
    cropImg(newValue, oldValue) {
      if (oldValue === '' && newValue){
        this.initialImage = newValue
        this.imgSrc = newValue
      }
    }
  },
  data() {
    return {
      loading: false,
      initialImage: '',
      imgSrc: '',
      cropImg: '',
      data: null,
    };
  },
  created(){
    this.cropImg = this.value
    console.log(this.cropImg)
  },
  methods: {
    async cropImage() {
      this.loading = true;
      try {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();

        let {data} = await this.$http({
          method: 'POST',
          url: `${lovemap.rest}lm/v1/lovemap/upload-image`,
          data: {
            image: this.cropImg
          }
        })
        if (data) {
          let {url} = data
          this.$emit('input', url)
          this.imgSrc = url;
          this.$modal.hide('image-cropper-modal')
        }
      } catch (e) {
        console.error(e)
        console.error(e.stack)
      }
      this.loading = false;
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.imgSrc = this.initialImage;
      this.$refs.cropper.reset();
      this.$refs.cropper.replace(this.initialImage);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.initialImage = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    openImageCropper() {
      this.$modal.show('image-cropper-modal')
    },
    closeImageCropper() {
      this.$modal.hide('image-cropper-modal')
    }
  },
}
</script>

<style lang="scss" scoped>

.actions ::v-deep .lm-button{
  width: auto;
  margin: 2px 3px;
}
.cropper-area {
  width: 100%;
}

.actions {
  margin-top: 1rem;
}

.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

textarea {
  width: 100%;
  height: 100px;
}

.preview-area {
  width: 307px;
}

.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}

.preview-area p:last-of-type {
  margin-top: 1rem;
}

.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}

.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}

.cropped-image img {
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
.viewport-confirm-header {
  width: 100%;
  background: #EC7A5C;
  padding: 10px;

  h4 {
    text-align: center;
    color: white;
  }
}

.viewport-confirm-message {
  padding: 35px 25px;
  padding-bottom: 85px;

  p {
    text-align: center;
  }
}

.lovemap-product-preview {
  text-align: center;
  margin-bottom: 20px;

  &--inner {
    display: inline-block;
  }

  .loading-text {
    margin-top: 15px;
  }

  .preview-image {
    border: 1px solid #d7d7d7;
  }

  img {
    max-height: 350px;
  }
}

.viewport-confirm-container {
  position: relative;
  height: 100%;

  .bottom {
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    /*text-align: center;*/
    > div {
      display: inline-block;
      width: 50%;
      @media only screen and (min-width: 501px) {
        .lm-button {
          margin-bottom: 20px;
        }
      }
      @media only screen and (max-width: 500px) {
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
      text-align: center;
    }
  }
}
</style>


<style lang="scss" scoped>
.lm-toggle-item {
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  margin: 5px 15px;
  padding: 10px 14px;
  background: #d2d2d2;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  min-width: 83px;
  text-align: center;
}
.cropper-btn{
  margin: 10px 0
}
</style>